export default __webpack_public_path__ + "static/tabs-importance-dont-3e5524392f83d455ea79ee480faaaa9bd6da510df6c6ab7a331fa85a7a8b60d4.png";